module.exports = __webpack_public_path__ + "assets/arrow-long-right.40c15efe.svg";